import React from 'react';

export default function SuccessMessage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-primary-light">
      <div className="bg-white p-8 rounded-xl shadow-md max-w-md w-full text-center">
        <h2 className="text-2xl font-bold text-primary mb-4">Tak for din indsendelse!</h2>
        <p className="text-primary mb-4">Vi har modtaget dine oplysninger og vender tilbage hurtigst muligt.</p>
      </div>
    </div>
  );
}
